import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

// import Dialog, {
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   withMobileDialog,
// } from 'material-ui/Dialog';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import Spinner from '../Spinner';
import swal from 'sweetalert2';
//import FacebookLogin from 'react-facebook-login';

import { connect } from 'react-redux';

// Styles
import styles from './styles';

// Actions
import { attemptLogin } from '../../modules/login';

/**
 *  Login Dialog Component
 */
class LoginDialog extends Component {
  state = {
    email: '',
    password: ''
  };

  componentDidUpdate(prevProps, prevState) {
    const {
      attemptingLogin,
      loginSuccess,
      attemptingFacebookLogin,
      facebookLoginSuccess,
      error
    } = this.props;

    // Successful login
    if (prevProps.attemptingLogin && !attemptingLogin && loginSuccess) {
      this._showLoggedInAlert();
      return this.handleClose();
    }

    // Failed login
    if (prevProps.attemptingLogin && !attemptingLogin && !loginSuccess) {
      return this.setState({ errorText: error }); // Set Error message
    }

    // Successful facebook login
    if (
      prevProps.attemptingFacebookLogin &&
      !attemptingFacebookLogin &&
      facebookLoginSuccess
    ) {
      this._showLoggedInAlert();
      return this.handleClose();
    }

    // Failed facebook login
    if (
      prevProps.attemptingFacebookLogin &&
      !attemptingFacebookLogin &&
      !facebookLoginSuccess
    ) {
      return this.setState({ errorText: error }); // Set Error message
    }
  }

  _showLoggedInAlert = () => {
    swal({
      position: 'top-end',
      type: 'success',
      title: 'Successfully logged in',
      showConfirmButton: false,
      timer: 1500
    });
  };

  handleClose = () => {
    this.props.handleClose();
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  _handleLogin = () => {
    const { email, password } = this.state;

    this.setState({ errorText: '' });

    // Submit login action
    this.props.login({ username: email, password });
  };

  _handleForgotPassword = () => {
    this.props.handleForgotPassword();
  };

  _handleSignup = () => {
    this.props.handleSignup();
  };

  _renderLoading = () => {
    const { fullScreen, classes } = this.props;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title">
        <DialogContent style={styles.loadingContent}>
          <DialogContentText style={{ textAlign: 'center', marginBottom: 20 }}>
            Attempting to log in...
          </DialogContentText>
          <Spinner loading={true} />
        </DialogContent>
      </Dialog>
    );
  };

  render() {
    const {
      fullScreen,
      classes,
      attemptingLogin,
      attemptingFacebookLogin
    } = this.props;
    const { errorText } = this.state;

    // if attempting to login
    if (attemptingLogin || attemptingFacebookLogin) {
      return this._renderLoading();
    }

    return (
      <Dialog
        fullScreen={fullScreen}
        open={this.props.open}
        key={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle id="responsive-dialog-title">
          {'Login to Grow App'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Login to access all features of Grow App
          </DialogContentText>

          <TextField
            required
            id="email"
            label="Email"
            placeholder="Email"
            margin="normal"
            fullWidth
            value={this.state.email}
            onChange={this.handleChange('email')}
          />

          <TextField
            required
            type="password"
            id="password"
            label="Password"
            placeholder="Password"
            margin="normal"
            fullWidth
            value={this.state.password}
            onChange={this.handleChange('password')}
          />

          {/* Error Prompt */}
          <p style={styles.errorText}>{errorText ? `**${errorText}` : ''}</p>

          {/* Alternate Options */}
          <div style={styles.alternateOptionsContainer}>
            <span
              style={{
                marginTop: 10,
                cursor: 'pointer',
                color: 'rgba(0,0,0,0.5)',
                display: 'block'
              }}
              onClick={this._handleForgotPassword}>
              Forgot your password?
            </span>

            {/*
            <span
              style={{ marginTop: 10, cursor: 'pointer', color: 'rgba(0,0,0,0.5)' }}
              onClick={this._handleSignup}
            >{"Don't have an account?"}</span>
            */}
          </div>
        </DialogContent>

        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={this._handleLogin} color="primary" variant="raised">
            Login
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

LoginDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired
};

LoginDialog = withMobileDialog()(LoginDialog);

function mapStateToProps(state, ownProps) {
  return {
    token: state.user.token,

    attemptingLogin: state.login.attemptingLogin,
    loginSuccess: state.login.loginSuccess,
    //open: state.login.open,

    // attemptingFacebookLogin: state.login.attemptingFacebookLogin,
    // facebookLoginSuccess: state.login.facebookLoginSuccess,

    error: state.login.error
  };
}

function mapDispatchToProps(dispatch) {
  return {
    login: data => dispatch(attemptLogin(data))
    //facebookLogin:(data)=>dispatch(facebookLogin(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginDialog);



// WEBPACK FOOTER //
// ./src/components/LoginDialog/index.js